export function confluenceResizeCase() {
  $("body").ready(function () {
    var domain = window.location.hostname;
    var bodyH;

    if (window.location !== window.parent.location) {
      domain = getDomain(document.referrer);
    }

    function getDomain(link) {
      var iframeDomain,
        parser = document.createElement('a');
      parser.href = link;
      iframeDomain = parser.protocol + '//' + parser.hostname;
      return iframeDomain;
    }

    if (addEventListener) {
      addEventListener('message', listener, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', listener);
    }

    function listener(event: any = undefined) {
      if (event && event?.data === 'need_height') {
        var message = {
          type: 'resize',
          height: $('body').height() + 'px',
        };

        try {
          window.parent.postMessage(JSON.stringify(message), domain);
          /* Add the urls where the C69-10 component is used */
          window.parent.postMessage(JSON.stringify(message), 'http://localhost');
          window.parent.postMessage(JSON.stringify(message), 'https://www.nissan.com.br');
          window.parent.postMessage(JSON.stringify(message), 'http://www.local.nissan.com.br/');
          window.parent.postMessage(JSON.stringify(message), 'https://digital.nissan.com.br');
          window.postMessage(JSON.stringify(message), 'https://www.nissan.com.br');
        } catch (error) {
          console.error(error);
        }
      }
    }

    function checkForNewHeight() {
      var newBodyH = $('body').height();
      if (bodyH !== newBodyH) {
        bodyH = newBodyH;
        listener({
          data: 'need_height'
        });
      }

    }

    setInterval(checkForNewHeight, 250);
    setTimeout(listener, 2000)
  });
}